<template>
<div :class="'col-span-6 sm:col-span-' + props.colspan + (Number(props.colspan ?? 0) < 6 ? ' mt-7' : '')">
  <div class="flex items-center justify-between">    
    <button type="button" 
      :class="[
        props.modelValue ? 'bg-oekoprofitgruen' : 'bg-gray-300',
        props.readonly ? 'opacity-50 cursor-default' : '',
        'mr-3 relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent',
        'transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-oekoprofitgruen focus:ring-offset-2'
      ]"
      role="switch" 
      @click="updateValue(!(props.modelValue ?? false))"
      :disabled="props.readonly"
      aria-checked="false" :aria-labelledby="`${props.id}-label`" :aria-describedby="`${props.description}-description`"
    >
      <span 
        aria-hidden="true" 
        :class="[
          props.modelValue ? 'translate-x-5' : 'translate-x-0',
          'pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out'
        ]"
      />
    </button>
    <span v-if="props.label" class="flex flex-grow flex-col">
      <span class="text-sm font-medium text-gray-700" :id="`${props.id}-label`">
        {{ `${props.label}${props.required ? ' *' : ''}` }}
      </span>
      <span v-if="props.description" class="text-sm text-gray-500" :id="`${props.description}-description`">
        {{ props.description }}
      </span>
    </span>
  </div>
</div>
</template>

<script setup lang="ts">
import { useValidation } from '../../../composables/Validation';

interface IComponentProps {
  id: string;
  label?: string;
  description?: string;
  colspan: string;
  modelValue?: boolean;
  required?: boolean;
  readonly?: boolean;
}

const props: IComponentProps = defineProps<IComponentProps>();

var { isRequired } = useValidation(props.label, () => props.modelValue);

if(props.required){
  isRequired();
}

const emit = defineEmits(['update:modelValue']);

const updateValue = (value: boolean) => {
  emit('update:modelValue', value)
};
</script>
